module.exports = __webpack_public_path__ + "img/C07TechBurningPitch_ua.085705ff.webp";